import emailLabelsSaga from './sagas'
import slice from './reducer'

export const {
  fetchRequest: fetchEmailLabelsRequest,
  fetchSuccess: fetchEmailLabelsSuccess,
  fetchError: fetchEmailLabelsError,
  fetchDetailsRequest: fetchEmailLabelDetailsRequest,
  fetchDetailsSuccess: fetchEmailLabelDetailsSuccess,
  createRequested: createEmailLabelRequested,
  createSuccess: createEmailLabelSuccess,
  createError: createEmailLabelError,
  updateRequested: updateEmailLabelRequested,
  updateSuccess: updateEmailLabelSuccess,
  updateError: updateEmailLabelError,
} = slice.actions

export default slice.reducer
export { emailLabelsSaga }
